export enum LinkTheme {
  LIGHT,
  DARK,
}
